export const quickTimeRange = [
  {
    label: "今天",
    value: "this-day"
  },
  {
    label: "昨天",
    value: "last-day"
  },
  {
    label: "明天",
    value: "next-day"
  },
  {
    label: "本周",
    value: "this-week"
  },
  {
    label: "上周",
    value: "last-week"
  },
  {
    label: "下周",
    value: "next-week"
  },
  {
    label: "本月",
    value: "this-month"
  },
  {
    label: "上月",
    value: "last-month"
  },
  {
    label: "下月",
    value: "next-month"
  },
  {
    label: "本季度",
    value: "this-quarter"
  },
  {
    label: "上季度",
    value: "last-quarter"
  },
  {
    label: "下季度",
    value: "next-quarter"
  },
  {
    label: "本年度",
    value: "this-year"
  },
  {
    label: "上年度",
    value: "last-year"
  },
  {
    label: "下年度",
    value: "next-year"
  }
]
